import React, { useState, useEffect, useCallback } from "react";
import { deleteBranch, getBranch } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { EditBranchs } from "./Form";
import { toast } from "react-toastify";
import { Deletemodel } from "../../Common/Functions";

const ListBranch = () => {
  const [branches, setBranches] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isAddMode, setIsAddMode] = useState(true);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [deletemodel, showDeletemodel] = useState(false);
  const [deleteID, setDeleteID] = useState("");

  const navigate = useNavigate();
  

  const fetchBranches = useCallback(async (page = 1, text = "") => {
    try {
      const response = await getBranch(page, text);
      if (response.data?.data) {
        setBranches(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  }, []);

  useEffect(() => {
    fetchBranches(page, search);
  }, [page, search, fetchBranches]);

  const handleCardClick = (branch) => {
    // navigate(`/shops?branchId=${branch.id}`, { state: branch });
    navigate(`/shops`, { state: { branchId: branch.id, branchTitle: branch.title } });

  };

  const handleAddBranch = () => {
    setIsAddMode(true);
    setSelectedBranch(null);
    setShowModal(true);
  };

  const handleEdit = (branch) => {
      setSelectedBranch(branch);
      setIsAddMode(false); // Set to edit mode
      setShowModal(true);
  }

  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  }


  const   handleDelete = async () => {
    try {
      await deleteBranch(deleteID);
      toast.success("Branch deleted successfully");
      fetchBranches(); // Re-fetch branch after deletion
      showDeletemodel(false)
    } catch (error) {
      console.error("Error deleting branch:", error);
      toast.error("Error deleting branch");
    }
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-center align-items-center  mb-3">
        <div className="col-4 position-relative" style={{ width: "30%" }}>
          <input
            type="text"
            className="form-control form-control-sm mt-4"
            placeholder="Search..."
            onChange={(e) => setSearch(e.target.value)}
          />
          <img
            src="/assets/images/icons/search.png"
            alt="Search Icon"
            style={{
              position: "absolute",
              right: "12px",
              top: "70%",
              transform: "translateY(-50%)",
              height: "18px",
              pointerEvents: "none",
            }}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end align-items-end">
      <button
          className="btn btn-primary text-small mx-4 px-3"
          onClick={handleAddBranch}
        >
          Add Branch
        </button>
      </div>

      <div className="product-grid row" style={{ padding: "10px 25px"}} >
  {branches
    .filter(
      (branch) =>
        branch.title.toLowerCase().includes(search.toLowerCase())
    )
    .map((branch, index) => (
      <div className="col-12 col-md-6 col-lg-3 mb-3" key={index}>
        <div
          className="card h-100 text-center"
          style={{
            cursor: "pointer",
            padding: "6px",
          }}
        >
          {branch.title != "Oman" && (
                  <div className='d-flex justify-content-end'>
                  <div className='mt-2 mx-3 text-end' role="button"
                   onClick={() => handleEdit(branch)}
                   >
                    <i class="fas fa-edit text-success"></i>
                  </div>
                  <div className='mt-2 mx-3 text-danger text-end' role="button"
                   onClick={() => handledeletemodel(branch.id)}
                   >
                    <i class="fas fa-trash text-danger"></i>
                  </div>
                  </div>
                  )}

              <div className="card-body"           onClick={() => handleCardClick(branch)}>
                <img
                  src={"/assets/images/tech_logo.webp"}
                  width={"100px"}
                  style={{ marginTop: "10px" }}
                  alt={`${branch.name} Icon`}
                />
                <h5 className="card-title mt-4">{branch.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <EditBranchs
          showModal={showModal}
          setShowModal={setShowModal}
          fetchBranchs={fetchBranches}
          selectedBranch={selectedBranch}
          isAddMode={isAddMode}
        />
      )}
    </div>
  );
};

export default ListBranch;
